/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown>, role: NonNullable<unknown> }} Team_Member_Invited_AuditInputs */

const en_team_member_invited_audit = /** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitation sent to ${i?.email} as ${i?.role}`)
};

const es_team_member_invited_audit = /** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitación enviada a ${i?.email} como ${i?.role}`)
};

const fr_team_member_invited_audit = /** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitation envoyée à ${i?.email} en tant que ${i?.role}`)
};

const de_team_member_invited_audit = /** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einladung gesendet an ${i?.email} als ${i?.role}`)
};

const id_team_member_invited_audit = /** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Undangan dikirim ke ${i?.email} sebagai ${i?.role}`)
};

/** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */
const ja_team_member_invited_audit = en_team_member_invited_audit;

/** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */
const zh_team_member_invited_audit = en_team_member_invited_audit;

/** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */
const ar_team_member_invited_audit = en_team_member_invited_audit;

/** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */
const it_team_member_invited_audit = en_team_member_invited_audit;

/** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */
const ru_team_member_invited_audit = en_team_member_invited_audit;

/** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */
const pt_team_member_invited_audit = en_team_member_invited_audit;

/** @type {(inputs: Team_Member_Invited_AuditInputs) => LocalizedString} */
const ko_team_member_invited_audit = en_team_member_invited_audit;

/**
* | output |
* | --- |
* | "Invitation sent to {email} as {role}" |
*
* @param {Team_Member_Invited_AuditInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_member_invited_audit = /** @type {((inputs: Team_Member_Invited_AuditInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Member_Invited_AuditInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_member_invited_audit(inputs)
	if (locale === "es") return es_team_member_invited_audit(inputs)
	if (locale === "fr") return fr_team_member_invited_audit(inputs)
	if (locale === "de") return de_team_member_invited_audit(inputs)
	if (locale === "ja") return ja_team_member_invited_audit(inputs)
	if (locale === "zh") return zh_team_member_invited_audit(inputs)
	if (locale === "ar") return ar_team_member_invited_audit(inputs)
	if (locale === "id") return id_team_member_invited_audit(inputs)
	if (locale === "it") return it_team_member_invited_audit(inputs)
	if (locale === "ru") return ru_team_member_invited_audit(inputs)
	if (locale === "pt") return pt_team_member_invited_audit(inputs)
	return ko_team_member_invited_audit(inputs)
});